import { useState } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { OtpLoginPage as SharedOtpLoginPage, AuthSplitLayout } from '@discovr/ui';
import { domainJoin } from '@discovr/api';

const joinRoute = getRouteApi('/join/$brandSlug');

export default function JoinPage() {
  const { brandSlug } = joinRoute.useParams();
  const { email } = joinRoute.useSearch();
  const [submitted, setSubmitted] = useState<{ email: string; brandName: string } | null>(null);

  if (submitted) {
    return (
      <AuthSplitLayout backTo="/login" headline="Request submitted">
        {/* role="status" announces the state swap to assistive tech — this
            replaces the whole page in place with no route change, so without
            it a screen-reader user gets no signal the submit succeeded. */}
        <p role="status" className="text-body-md-regular text-muted-foreground">
          We&apos;ve sent your request to join {submitted.brandName || 'this workspace'} to its team. You&apos;ll get
          an email at {submitted.email} once it&apos;s reviewed.
        </p>
      </AuthSplitLayout>
    );
  }

  return (
    <SharedOtpLoginPage
      appName="Discovr"
      initialEmail={email}
      headline="Request access."
      subheadline="Enter your work email and we'll send you a 6-digit code to confirm your request."
      submitLabel="Request access"
      codeSubheadline="We sent a 6-digit code to the email you entered."
      onRequestOtp={async (emailAddr) => {
        await domainJoin.requestJoin({ brand: brandSlug, email: emailAddr });
      }}
      onVerifyOtp={async ({ email: emailAddr, code }) => {
        const res = await domainJoin.verifyJoin({ brand: brandSlug, email: emailAddr, code: code ?? '' });
        setSubmitted({ email: emailAddr, brandName: res.brand_name });
      }}
    />
  );
}
